"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styler = _interopRequireDefault(require("../../Styler/styler"));

var _dropdownUtils = require("../dropdownUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownMenu = function DropdownMenu(_ref) {
  var children = _ref.children,
      small = _ref.small,
      large = _ref.large;
  var allowedModifiers = {
    small: small,
    large: large
  };
  return _react.default.createElement(_styler.default, {
    classNames: "co-dropdown__menu",
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, children);
  });
};

DropdownMenu.propTypes = {
  children: _propTypes.any,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: _dropdownUtils.sizeProps,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: _dropdownUtils.sizeProps
};
DropdownMenu.displayName = 'Dropdown.Menu';
var _default = DropdownMenu;
exports.default = _default;
DropdownMenu.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Dropdown.Menu",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "sizeProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    }
  }
};